import { passStatePriority } from '../../../../../PassState';

const getWorstPassState = (passStates = []) =>
  passStates.sort((a, b) => (passStatePriority.indexOf(b) ?? -1) - (passStatePriority.indexOf(a) ?? -1))[0];

export default getWorstPassState;